module.exports = __webpack_public_path__ + "static/img/go_back.39698bc2.png";